import React from 'react';
import { METRIC_BUYERS, METRIC_RATING } from '../lib/config';
const metrics = [{
  value: METRIC_BUYERS,
  label: 'Organizadoras usando el sistema'
}, {
  value: '6 + 5',
  label: 'Tomos y herramientas de campo'
}, {
  value: `${METRIC_RATING} /5`,
  label: 'Valoración promedio'
}, {
  value: 'De punta a punta',
  label: 'De la primera reunión a la recomendación'
}];
export function SocialProofBar() {
  return <section className="w-full bg-ink py-10 text-ivory md:py-12" aria-label="Prueba social" data-id="element-188" data-mp="32i1vamhd84ou">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-189" data-mp="2xlbh64p4fj62">
        <dl className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-4" data-id="element-190" data-mp="2thwzl9ljauqi">
          {metrics.map(metric => <div key={metric.label} className="text-center" data-id="element-191" data-mp="2ok4utezsje4w">
              <dt className="sr-only" data-id="element-192" data-mp="2ologxm84ojel">{metric.label}</dt>
              <dd data-id="element-193" data-mp="1i417z1dg0tie">
                <span className="block font-serif text-2xl text-gold sm:text-3xl" data-id="element-194" data-mp="1i4kt0qye3y0n">
                  {metric.value}
                </span>
                <span className="mt-2 block text-[11px] uppercase tracking-[0.14em] text-ivory/60" data-id="element-195" data-mp="18okn3jvt1hwy">
                  {metric.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}